import React from 'react'

interface TaskAttentionIconProps {
  size?: number
  className?: string
  level?: 'high' | 'medium' | 'low'
}

/**
 * Attention flag icon with optional colored variants.
 *
 * @example
 * // Default (no attention set) — uses currentColor
 * <TaskAttentionIcon size={16} />
 *
 * @example
 * // Colored variants by attention level
 * <TaskAttentionIcon level="high" />   // Red flag
 * <TaskAttentionIcon level="medium" /> // Orange flag
 * <TaskAttentionIcon level="low" />    // Blue flag
 */
export const TaskAttentionIcon: React.FC<TaskAttentionIconProps> = ({ size = 16, className, level }) => {
  if (level === 'high') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M2.67 10C2.67 10 3.33 9.33 5.33 9.33C7.33 9.33 8.67 10.67 10.67 10.67C12.67 10.67 13.33 10 13.33 10V2C13.33 2 12.67 2.67 10.67 2.67C8.67 2.67 7.33 1.33 5.33 1.33C3.33 1.33 2.67 2 2.67 2V10Z" fill="#DC2626"/>
        <path d="M2.67 10C2.67 10 3.33 9.33 5.33 9.33C7.33 9.33 8.67 10.67 10.67 10.67C12.67 10.67 13.33 10 13.33 10V2C13.33 2 12.67 2.67 10.67 2.67C8.67 2.67 7.33 1.33 5.33 1.33C3.33 1.33 2.67 2 2.67 2V10ZM2.67 10V14.67" stroke="#FCA5A5" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.67 2V10V14.67" stroke="#B91C1C" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  }

  if (level === 'medium') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M2.67 10C2.67 10 3.33 9.33 5.33 9.33C7.33 9.33 8.67 10.67 10.67 10.67C12.67 10.67 13.33 10 13.33 10V2C13.33 2 12.67 2.67 10.67 2.67C8.67 2.67 7.33 1.33 5.33 1.33C3.33 1.33 2.67 2 2.67 2V10Z" fill="#F97316"/>
        <path d="M2.67 10C2.67 10 3.33 9.33 5.33 9.33C7.33 9.33 8.67 10.67 10.67 10.67C12.67 10.67 13.33 10 13.33 10V2C13.33 2 12.67 2.67 10.67 2.67C8.67 2.67 7.33 1.33 5.33 1.33C3.33 1.33 2.67 2 2.67 2V10ZM2.67 10V14.67" stroke="#FDBA74" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.67 2V10V14.67" stroke="#C2410C" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  }

  if (level === 'low') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M2.67 10C2.67 10 3.33 9.33 5.33 9.33C7.33 9.33 8.67 10.67 10.67 10.67C12.67 10.67 13.33 10 13.33 10V2C13.33 2 12.67 2.67 10.67 2.67C8.67 2.67 7.33 1.33 5.33 1.33C3.33 1.33 2.67 2 2.67 2V10Z" fill="#2563EB"/>
        <path d="M2.67 10C2.67 10 3.33 9.33 5.33 9.33C7.33 9.33 8.67 10.67 10.67 10.67C12.67 10.67 13.33 10 13.33 10V2C13.33 2 12.67 2.67 10.67 2.67C8.67 2.67 7.33 1.33 5.33 1.33C3.33 1.33 2.67 2 2.67 2V10ZM2.67 10V14.67" stroke="#93C5FD" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.67 2V10V14.67" stroke="#1E40AF" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  }

  // Default: no attention level set — monochrome with currentColor
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M2.67 10C2.67 10 3.33 9.33 5.33 9.33C7.33 9.33 8.67 10.67 10.67 10.67C12.67 10.67 13.33 10 13.33 10V2C13.33 2 12.67 2.67 10.67 2.67C8.67 2.67 7.33 1.33 5.33 1.33C3.33 1.33 2.67 2 2.67 2V10ZM2.67 10V14.67" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
